import {Entity} from 'app/core/main.entity';
import {SwitchItem} from './switch.entity';

export class Branch extends Entity {
  id: number;
  name: string;

  getSwitchItem(): SwitchItem {
    return {
      id: this.id,
      title: this.name,
      data: {
        type: 'branch'
      }
    };
  }
}
